import { FC } from "react";
import { Box, Flex } from "@smile2impress/components/relaunch";
import { UniversalImageElement } from "templates/relaunch/primitives/UniversalImageElement";
import { DirectionType } from "templates/relaunch/MultiColumnSlider/MultiColumnSlider.types";

import { ColumnBeforeAndAfterProps } from "./ColumnBeforeAndAfter.types";

export const ColumnBeforeAndAfter: FC<ColumnBeforeAndAfterProps> = ({
    image,
    withExpansion,
    direction = DirectionType.Vertical,
}) => {
    return (
        <Flex
            direction={["column", "column", "column"]}
            justifyContent="space-between"
        >
            {image && (
                <Box mb={[1, 1, 0]} borderRadius="sm" overflow="hidden">
                    <UniversalImageElement
                        {...image}
                        withExpansion={withExpansion}
                        direction={direction}
                    />
                </Box>
            )}
        </Flex>
    );
};
